import { createWeb3DEngine } from '@itero/web-3d-engine';
import { getIsDebugMode } from '@shared/utils/common.js';

import('./bootstrap').catch((err) => console.error(err));

// Register the web-3d-engine custom element
const isDebugMode = getIsDebugMode();
if (isDebugMode) {
  createWeb3DEngine();
}
